/** @format */

import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { chain } from '@core/chain';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'clp-third-party-content',
	templateUrl: './third-party.component.html',
	styleUrl: './third-party.component.scss',
	standalone: false
})
export class ThirdPartyComponent implements OnInit {
	@Input() seoResponse: any;

	searchDexResponse: any;
	certonaRecommendationsResponse = null;
	proTipsContent: any;

	chainAbbr = chain.chainIdentifierAbbr;

	constructor(
		@Inject(WINDOW) private window: Window,
		private changeRef: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.handleSearchDexResponse(this.seoResponse);
		// Check to see if a Certona callback has been defined already
		if (typeof this.window.certonaRecommendations === 'undefined') {
			this.window.DSGShoppingPathJS = {};
			// Assign the Component method to the global Window so that Certona can execute it, passing in `this` as context
			this.window.certonaRecommendations = this.getCertonaRecommendations.bind(this);
			this.window.DSGShoppingPathJS.certonaRecommendations =
				this.getCertonaRecommendations.bind(this);
		}
	}

	handleSearchDexResponse(response: any) {
		this.searchDexResponse = response;

		if (this.searchDexResponse.articles && this.searchDexResponse.articles.length > 0) {
			const articles = response.articles;
			const desktopContent: any = [];
			const tabletContent: any = [];

			let i;
			let j;
			let temparray;
			const chunk = 4;
			const tabchunk = 3;

			// Desktop ProTips Content
			for (i = 0, j = articles.length; i < j; i += chunk) {
				temparray = articles.slice(i, i + chunk);
				desktopContent.push(temparray);
			}

			// Tablet ProTips Content
			for (i = 0, j = articles.length; i < j; i += tabchunk) {
				temparray = articles.slice(i, i + tabchunk);
				tabletContent.push(temparray);
			}

			this.proTipsContent = {
				articles,
				condensedArticle: desktopContent,
				tabletArticle: tabletContent
			};
			this.changeRef.detectChanges();
		}
	}

	/**
	 * @description
	 * Callback function for Certona to process the product recommendations.  It sets the response on the component to be passed
	 * into the child components
	 *
	 * @param certonaResponse
	 */
	getCertonaRecommendations(certonaResponse: any) {
		// Set the response on the component
		this.certonaRecommendationsResponse = certonaResponse;
		this.changeRef.detectChanges();
	}
}
